export default "__VITE_ASSET__BUCRFzOi__"